/**
 * VoiceDock — the universal primary action, always pinned at the bottom
 * (predictable for distracted/elderly users). A frosted-glass bar (overlay
 * material) carrying the ambient orb as a small presence, a text/voice prompt,
 * and the mic. Voice is first-class but text is equally available, never
 * voice-only. On Home/Car the bar opens the Thread; in the Thread it is input.
 */
import { Icon } from './Icon';

export function VoiceDock({
  placeholder,
  onActivate,
  onMic,
  showOrb = true,
}: {
  placeholder: string;
  /** Tapping the bar (opens the thread / focuses input). */
  onActivate?: () => void;
  /** Tapping the mic. Defaults to onActivate. */
  onMic?: () => void;
  /** Show the small ambient orb at the start of the bar. */
  showOrb?: boolean;
}) {
  return (
    <div className="kol-glass flex items-center gap-3 rounded-[22px] ps-[14px] p-2 shadow-kol-3">
      {showOrb && <span className="kol-orb shrink-0" style={{ width: 30, height: 30 }} aria-hidden />}
      <button
        type="button"
        onClick={onActivate}
        className="flex-1 text-start text-[16.5px] font-medium text-kol-ink-faint min-h-[46px]"
      >
        {placeholder}
      </button>
      <button
        type="button"
        onClick={onMic ?? onActivate}
        aria-label="דברו אל הרכב"
        className="w-12 h-12 rounded-full grid place-items-center text-white shrink-0"
        style={{
          background: 'linear-gradient(155deg, #2E7D5B, #1F4E3D)',
          boxShadow: '0 8px 18px -6px rgba(18, 50, 38, 0.55)',
        }}
      >
        <Icon name="mic" size={21} strokeWidth={1.7} />
      </button>
    </div>
  );
}
